import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
//Custom
import Grid from "@mui/material/Grid"; // Grid version 1

import grain from "./../../assets/images/grain.svg";
import { images as imageValues } from "../../imageValues";

import { Paper } from "@mui/material";
import Carousel from "react-material-ui-carousel";
import { blue, orange } from "@mui/material/colors";

import Button from "../../component/Button/Button";
// import imageValues from "../../imageValues";
import stringValues from "../../stringValues";
import { correctTwoSound, wrongAnswerSound } from "../../assets/audio/audio";
import { AxlTracker } from "../../utils";
import { useAxL } from "../../AxLContext";

import "./../../App.css";
import { CreditMsgDiv } from "./QuestionsModalStyle";

const QuestionModal = ({
  questionObject,
  onQuestionChange,
  questionNo,
  playPauseSoundState,
  changeLanguageState,
  gameQuizes,
}) => {
  const axl = useAxL();
  const images = questionObject.images;
  const questionImage = questionObject.questionImage;
  const initialImageId = questionObject.images[0].id;
  const [isSolutionTried, setIsSolutionTried] = useState(false);
  const [draggedImageId, setDraggedImageId] = useState(0);
  const [isSolutionCorrect, setIsSolutionCorrect] = useState(false);
  const [showSnackBar, setShowSnackBar] = useState(false);
  const [snackBarValue, setSnackBarValue] = useState("");
  const [carouselImageId, setCarouselImageId] = useState(initialImageId);
  const [mobileWidth, setMobileWidth] = useState(window.innerWidth);

  useEffect(() => {
    if (questionObject.questionRound === 6 && questionObject.id === 3) {
      return gameQuizes("All quizes are completed");
    }
  }, [questionObject]);

  useEffect(() => {
    const handleResize = () => {
      setMobileWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleDragStart = (event) => {
    setIsSolutionTried(false);
    setDraggedImageId(event.target.id);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setIsSolutionTried(true);
    const id = event.target.id;
    if (id === draggedImageId) {
      setIsSolutionCorrect(true);
    }
  };

  const handleTouchStart = (event) => {
    setDraggedImageId(event.target.id);
    setIsSolutionTried(false);
  };

  const handleTouchEnd = (event) => {
    event.preventDefault();
    setIsSolutionTried(true);
    if (carouselImageId === draggedImageId) {
      setIsSolutionCorrect(true);
    }
  };
  const handleImageClick = (event) => {
    // Perform actions when the image is clicked
    // You can use the event or image ID to determine which image was clicked
    const clickedImageId = event.target.id;
    event.preventDefault();
    setIsSolutionTried(true);
    // You can add your logic here based on the clicked image
    if (carouselImageId === clickedImageId) {
      setIsSolutionCorrect(true);
    }
    // For example, you can compare the clicked image with the expected answer.
  };
  useEffect(() => {
    if (isSolutionCorrect) {
      setTimeout(() => {
        onQuestionChange();
      }, 1000);
    }
  }, [onQuestionChange, isSolutionCorrect]);

  useEffect(() => {
    if (isSolutionTried && isSolutionCorrect) {
      setSnackBarValue(
        stringValues[changeLanguageState.data].quizAnswerCorrect
      );
      setShowSnackBar(true);
      playPauseSoundState.data && correctTwoSound.play();
    }
    if (isSolutionTried && !isSolutionCorrect) {
      setSnackBarValue(
        stringValues[changeLanguageState.data].quizAnswerInCorrect
      );
      setShowSnackBar(true);
      playPauseSoundState.data && wrongAnswerSound.play();
    }
    setTimeout(() => {
      setShowSnackBar(false);
      wrongAnswerSound.currentTime = 0;
      wrongAnswerSound.pause();
      correctTwoSound.currentTime = 0;
      correctTwoSound.pause();
    }, 1000);

    if (!isSolutionCorrect) {
      setIsSolutionTried(false);
    }
  }, [isSolutionTried, isSolutionCorrect]);

  const updateImageIdNext = (id) => {
    AxlTracker(axl, "Clicked on Next Arrow in Quiz", "Playing Quiz", 36, true);
    setCarouselImageId((parseInt(id) + 1).toString());
  };

  const updateImageIdPrev = (id) => {
    AxlTracker(
      axl,
      "Clicked on Previous Arrow in Quiz",
      "Playing Quiz",
      37,
      true
    );
    setCarouselImageId((parseInt(id) + 1).toString());
  };

  return (
    <>
      <Grid item container direction={"row"} xs={12} md={12} lg={12}>
        <Grid
          item
          container
          alignItems={"center"}
          justifyContent={"center"}
          mt={1}
          mb={1}
        >
          <div
            style={{
              backgroundColor: "#463048",
              backgroundImage: `url(${grain})`,
              backgroundBlendMode: "multiply",
              color: "white",
              padding: 10,
              paddingLeft: 20,
              paddingRight: 20,
            }}
          >
            {stringValues[changeLanguageState.data].questions} {questionNo}{" "}
            {stringValues[changeLanguageState.data].of} 3
          </div>
        </Grid>
        <div
          style={{
            width: "100%",
          }}
        >
          <Grid item container justifyContent={"center"}>
            <Paper
              sx={{
                mr: "0px",
                mb: "0px",
                ml: "0px",
                p: "44px",
                height: "100px",
                width: "200px",
                backgroundColor: blue[900],
                backgroundImage: `url(${grain})`,
                backgroundBlendMode: "multiply",
              }}
              variant="elevation"
              square={true}
              style={{
                border: "10px solid white",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                id={questionObject.solutionImageId}
                src={questionImage}
                style={{
                  maxHeight: 150,
                  maxWidth: 150,
                  touchAction: "none",
                  WebkitTouchCallout: "none",
                }}
                alt="QuizImage"
                draggable="true"
                onClick={handleImageClick}
                onDragStart={handleDragStart}
                onTouchStart={handleTouchStart}
                onTouchEnd={handleTouchEnd}
              />
            </Paper>
          </Grid>
          <Grid
            item
            container
            alignItems={"center"}
            justifyContent={"center"}
            mt={1}
            mb={1}
          >
            <div
              style={{
                backgroundColor: "#7e6014",
                backgroundImage: `url(${grain})`,
                backgroundBlendMode: "multiply",
                color: "#FFC000",
                paddingLeft: 28,
                maxWidth: 300,
                paddingRight: 28,
                textAlign: "center",
              }}
            >
              {mobileWidth > 1080 ? (
                <p>{stringValues[changeLanguageState.data].dragDrop}</p>
              ) : (
                <p>{stringValues[changeLanguageState.data].tapToMatch}</p>
              )}
            </div>
          </Grid>
          <Grid item container alignItems={"center"} justifyContent={"center"} mt={1}
            mb={1}>
            {!isSolutionCorrect ? (
              <Carousel
                className="carousel"
                animation="slide"
                navButtonsAlwaysVisible
                indicators={false}
                autoPlay={false}
                next={updateImageIdNext}
                prev={updateImageIdPrev}
                PrevIcon={
                  <img
                    src={imageValues.LEFTARROW}
                    height={30}
                    width={30}
                    alt="LeftArrowImage"
                  />
                }
                NextIcon={
                  <img
                    src={imageValues.LEFTARROW}
                    height={30}
                    width={30}
                    style={{
                      transform: "rotate(180deg)",
                    }}
                    alt="QuizImage"
                  />
                }
                navButtonsProps={{
                  style: {
                    backgroundColor: "transparent",
                  },
                }}
              >
                {images.map((image, index) => (
                  <Paper
                    sx={{
                      p: "60px",
                      height: "100px",
                      backgroundColor: orange[400],
                      justifyContent: "center",
                      alignItems: "center",
                      display: "flex",
                      backgroundImage: `url(${grain})`,
                      backgroundBlendMode: "multiply",
                    }}
                    key={index}
                    variant="elevation"
                    square={true}
                  >
                    <img
                      id={image.id}
                      src={image.name}
                      alt={`Slide ${index}`}
                      style={{
                        maxHeight: "200px",
                        maxWidth: "250px",
                        display: "flex",
                        alignItems: "center",
                      }}
                      onDragOver={handleDragOver}
                      onDrop={handleDrop}
                    />
                  </Paper>
                ))}
              </Carousel>
            ) : (
              <div
                style={{
                  padding: 60,
                  height: "100px",
                  width: "100%",
                  justifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                  backgroundImage: `url(${grain})`,
                  backgroundBlendMode: "multiply",
                  border: "10px solid white",
                  backgroundColor: orange[400],
                }}
              >
                <img
                  id={questionObject.solutionImageId}
                  src={questionObject.solutionFullImage}
                  style={{
                    maxHeight: "200px",
                    maxWidth: "240px",
                    display: "flex",
                    alignItems: "center",
                  }}
                  alt="QuizImage"
                />
              </div>
            )}
          </Grid>
        </div>
      </Grid>
      <Grid
        style={{
          width: "100%",
          marginTop: 20,
          justifyContent: "center",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div style={{ height: 30, marginTop: -15 }}>
          {showSnackBar && snackBarValue?.length && (
            <Button
              label={snackBarValue}
              style={{ width: "100%", fontSize: 13,height:35 }}
              disabled={true}
            />
          )}
        </div>
        <CreditMsgDiv>
          {stringValues[changeLanguageState.data].creditMessage}
        </CreditMsgDiv>
      </Grid>
    </>
  );
};
const mapStateToProps = (state) => ({
  playPauseSoundState: state.playPauseSound,
  changeLanguageState: state.changeLanguage,
});

export default connect(mapStateToProps, null)(QuestionModal);
